var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{staticClass:"close-icon",attrs:{"aria-label":"Close button"},on:{"click":function($event){return _vm.onClicked($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }